// Generated by scripts/build-ai-contract.ts
// Do not edit this file by hand.

import type { AiContractGeneratedData } from './ai-contract.types';

export const AI_CONTRACT_GENERATED: AiContractGeneratedData = {
  "headerDeclarations": [
    {
      "name": "SeedInput",
      "declarationLines": [
        "export type SeedInput = string | number | bigint;"
      ]
    },
    {
      "name": "OjProfile",
      "declarationLines": [
        "export type OjProfile = 'auto' | 'linux' | 'windows' | 'none';"
      ]
    },
    {
      "name": "MaybePromise",
      "declarationLines": [
        "export type MaybePromise<T> = T | Promise<T>;"
      ]
    },
    {
      "name": "DebugOptions",
      "declarationLines": [
        "export interface DebugOptions {",
        "    separator?: string;",
        "    printDims?: boolean;",
        "    printType?: boolean;",
        "    printStats?: boolean;",
        "    truncate?: number;",
        "    colors?: boolean;",
        "}"
      ]
    },
    {
      "name": "WeightOption",
      "declarationLines": [
        "export type WeightOption = boolean | [",
        "    min: number,",
        "    max: number",
        "];"
      ]
    },
    {
      "name": "GraphType",
      "declarationLines": [
        "export type GraphType = 'simple' | 'tree' | 'dag' | 'bipartite' | 'wheel' | 'complete';"
      ]
    },
    {
      "name": "GraphOptions",
      "declarationLines": [
        "export interface GraphOptions {",
        "    type?: GraphType;",
        "    directed?: boolean;",
        "    weighted?: WeightOption;",
        "    connected?: boolean;",
        "    noSelfLoops?: boolean;",
        "    oneBased?: boolean;",
        "    negativeCycle?: boolean;",
        "}"
      ]
    },
    {
      "name": "TreeType",
      "declarationLines": [
        "export type TreeType = 'random' | 'path' | 'star';"
      ]
    },
    {
      "name": "TreeOptions",
      "declarationLines": [
        "export interface TreeOptions {",
        "    type?: TreeType;",
        "    weighted?: WeightOption;",
        "    oneBased?: boolean;",
        "}"
      ]
    },
    {
      "name": "BinaryTreeType",
      "declarationLines": [
        "export type BinaryTreeType = 'random' | 'complete' | 'skewed';"
      ]
    },
    {
      "name": "BinaryTreeOptions",
      "declarationLines": [
        "export interface BinaryTreeOptions {",
        "    type?: BinaryTreeType;",
        "    oneBased?: boolean;",
        "}"
      ]
    },
    {
      "name": "SequenceOptions",
      "declarationLines": [
        "export type SequenceOptions = {",
        "    type: 'arithmetic';",
        "    start: number;",
        "    diff: number;",
        "    count: number;",
        "} | {",
        "    type: 'geometric';",
        "    start: number;",
        "    ratio: number;",
        "    count: number;",
        "} | {",
        "    type: 'fibonacci';",
        "    count: number;",
        "    first?: number;",
        "    second?: number;",
        "} | {",
        "    type: 'custom';",
        "    init: number[];",
        "    fn: (prev: number[]) => number;",
        "    count: number;",
        "};"
      ]
    },
    {
      "name": "FormatAtom",
      "declarationLines": [
        "export type FormatAtom = string | number | bigint | boolean | null | undefined;"
      ]
    },
    {
      "name": "FormatLine",
      "declarationLines": [
        "export interface FormatLine {",
        "    readonly kind: 'line';",
        "    readonly items: readonly FormatAtom[];",
        "}"
      ]
    },
    {
      "name": "FormatTable",
      "declarationLines": [
        "export interface FormatTable {",
        "    readonly kind: 'table';",
        "    readonly rows: readonly (readonly FormatAtom[])[];",
        "}"
      ]
    },
    {
      "name": "FormatGrid",
      "declarationLines": [
        "export interface FormatGrid {",
        "    readonly kind: 'grid';",
        "    readonly rows: readonly (string | readonly FormatAtom[])[];",
        "}"
      ]
    },
    {
      "name": "FormatRaw",
      "declarationLines": [
        "export interface FormatRaw {",
        "    readonly kind: 'raw';",
        "    readonly text: string;",
        "}"
      ]
    },
    {
      "name": "FormatNode",
      "declarationLines": [
        "export type FormatNode = FormatLine | FormatTable | FormatGrid | FormatRaw;"
      ]
    },
    {
      "name": "FormatDocument",
      "declarationLines": [
        "export interface FormatDocument {",
        "    readonly __genesisFormat: 2;",
        "    readonly nodes: readonly FormatNode[];",
        "}"
      ]
    }
  ],
  "datasetDeclarations": [
    {
      "name": "DatasetGenerateContext",
      "declarationLines": [
        "export interface DatasetGenerateContext {",
        "    caseIndex: number;",
        "    caseNumber: number;",
        "    caseName: string;",
        "    repeatIndex: number;",
        "    seed: string;",
        "    g: DatasetGenerator;",
        "}"
      ]
    },
    {
      "name": "DatasetValidationContext",
      "declarationLines": [
        "export interface DatasetValidationContext {",
        "    caseIndex: number;",
        "    caseNumber: number;",
        "    caseName: string;",
        "    repeatIndex: number;",
        "    tags: string[];",
        "    seed: string;",
        "    formattedInput: string;",
        "}"
      ]
    },
    {
      "name": "DatasetValidationResult",
      "declarationLines": [
        "export interface DatasetValidationResult {",
        "    ok: boolean;",
        "    reason?: string;",
        "}"
      ]
    },
    {
      "name": "DatasetValidationReturn",
      "declarationLines": [
        "export type DatasetValidationReturn = void | boolean | string | DatasetValidationResult;"
      ]
    },
    {
      "name": "DatasetStaticCase",
      "declarationLines": [
        "export interface DatasetStaticCase<TInput> {",
        "    name: string;",
        "    tags?: string[];",
        "    input: TInput;",
        "    generate?: never;",
        "    repeat?: never;",
        "}"
      ]
    },
    {
      "name": "DatasetGeneratedCase",
      "declarationLines": [
        "export interface DatasetGeneratedCase<TInput> {",
        "    name: string;",
        "    tags?: string[];",
        "    repeat?: number;",
        "    generate(ctx: DatasetGenerateContext): MaybePromise<TInput>;",
        "    input?: never;",
        "}"
      ]
    },
    {
      "name": "DatasetCase",
      "declarationLines": [
        "export type DatasetCase<TInput> = DatasetStaticCase<TInput> | DatasetGeneratedCase<TInput>;"
      ]
    },
    {
      "name": "DatasetConfig",
      "declarationLines": [
        "export interface DatasetConfig<TInput> {",
        "    solution: string;",
        "    outputDir?: string;",
        "    seed: SeedInput;",
        "    startFrom?: number;",
        "    runTimeoutMs?: number;",
        "    caseConcurrency?: number;",
        "    compiler?: string;",
        "    compilerFlags?: string[];",
        "    ojProfile?: OjProfile;",
        "    stackSizeBytes?: number;",
        "    manifestPath?: string | false;",
        "    format(input: TInput): FormatDocument | FormatNode;",
        "    validate?(input: TInput, context: DatasetValidationContext): MaybePromise<DatasetValidationReturn>;",
        "    cases: DatasetCase<TInput>[];",
        "}"
      ]
    },
    {
      "name": "Dataset",
      "declarationLines": [
        "export interface Dataset<TInput = unknown> {",
        "    readonly __genesisDataset: 2;",
        "    readonly config: DatasetConfig<TInput>;",
        "}"
      ]
    },
    {
      "name": "defineDataset",
      "declarationLines": [
        "export function defineDataset<TInput>(config: DatasetConfig<TInput>): Dataset<TInput>;"
      ]
    }
  ],
  "fmtMethods": [
    {
      "name": "line",
      "signature": "line(...items: FormatAtom[]): FormatLine;",
      "declarationLines": [
        "line(...items: FormatAtom[]): FormatLine;"
      ]
    },
    {
      "name": "lines",
      "signature": "lines(...rows: (FormatNode | readonly FormatAtom[] | FormatAtom)[]): FormatDocument;",
      "declarationLines": [
        "lines(...rows: (FormatNode | readonly FormatAtom[] | FormatAtom)[]): FormatDocument;"
      ]
    },
    {
      "name": "table",
      "signature": "table(rows: readonly (readonly FormatAtom[])[]): FormatTable;",
      "declarationLines": [
        "table(rows: readonly (readonly FormatAtom[])[]): FormatTable;"
      ]
    },
    {
      "name": "grid",
      "signature": "grid(rows: readonly (string | readonly FormatAtom[])[]): FormatGrid;",
      "declarationLines": [
        "grid(rows: readonly (string | readonly FormatAtom[])[]): FormatGrid;"
      ]
    },
    {
      "name": "raw",
      "signature": "raw(text: string): FormatRaw;",
      "declarationLines": [
        "raw(text: string): FormatRaw;"
      ]
    }
  ],
  "generatorMethods": [
    {
      "name": "int",
      "signature": "int(min: number, max: number): number;",
      "declarationLines": [
        "int(min: number, max: number): number;"
      ]
    },
    {
      "name": "ints",
      "signature": "ints(count: number, min: number, max: number): number[];",
      "declarationLines": [
        "ints(count: number, min: number, max: number): number[];"
      ]
    },
    {
      "name": "distinctInts",
      "signature": "distinctInts(count: number, min: number, max: number): number[];",
      "declarationLines": [
        "distinctInts(count: number, min: number, max: number): number[];"
      ]
    },
    {
      "name": "float",
      "signature": "float(min: number, max: number, precision?: number): number;",
      "declarationLines": [
        "float(min: number, max: number, precision?: number): number;"
      ]
    },
    {
      "name": "even",
      "signature": "even(min: number, max: number): number;",
      "declarationLines": [
        "even(min: number, max: number): number;"
      ]
    },
    {
      "name": "odd",
      "signature": "odd(min: number, max: number): number;",
      "declarationLines": [
        "odd(min: number, max: number): number;"
      ]
    },
    {
      "name": "prime",
      "signature": "prime(min: number, max: number): number;",
      "declarationLines": [
        "prime(min: number, max: number): number;"
      ]
    },
    {
      "name": "coprime",
      "signature": "coprime(min: number, max: number): [",
      "declarationLines": [
        "coprime(min: number, max: number): [",
        "    number,",
        "    number",
        "];"
      ]
    },
    {
      "name": "divisible",
      "signature": "divisible(min: number, max: number, d: number): number;",
      "declarationLines": [
        "divisible(min: number, max: number, d: number): number;"
      ]
    },
    {
      "name": "sequence",
      "signature": "sequence(options: SequenceOptions): number[];",
      "declarationLines": [
        "sequence(options: SequenceOptions): number[];"
      ]
    },
    {
      "name": "string",
      "signature": "string(len: number, charset?: string): string;",
      "declarationLines": [
        "string(len: number, charset?: string): string;"
      ]
    },
    {
      "name": "palindrome",
      "signature": "palindrome(len: number, charset?: string): string;",
      "declarationLines": [
        "palindrome(len: number, charset?: string): string;"
      ]
    },
    {
      "name": "word",
      "signature": "word(minLen: number, maxLen: number): string;",
      "declarationLines": [
        "word(minLen: number, maxLen: number): string;"
      ]
    },
    {
      "name": "words",
      "signature": "words(count: number, minLen: number, maxLen: number): string[];",
      "declarationLines": [
        "words(count: number, minLen: number, maxLen: number): string[];"
      ]
    },
    {
      "name": "brackets",
      "signature": "brackets(n: number, options?: {",
      "declarationLines": [
        "brackets(n: number, options?: {",
        "    types?: string;",
        "}): string;"
      ]
    },
    {
      "name": "array",
      "signature": "array<T>(count: number, itemGenerator: (index: number) => T): T[];",
      "declarationLines": [
        "array<T>(count: number, itemGenerator: (index: number) => T): T[];"
      ]
    },
    {
      "name": "sorted",
      "signature": "sorted(count: number, min: number, max: number, options?: {",
      "declarationLines": [
        "sorted(count: number, min: number, max: number, options?: {",
        "    order?: 'asc' | 'desc' | 'strictlyAsc' | 'strictlyDesc';",
        "}): number[];"
      ]
    },
    {
      "name": "sparse",
      "signature": "sparse(count: number, min: number, max: number, gap: number): number[];",
      "declarationLines": [
        "sparse(count: number, min: number, max: number, gap: number): number[];"
      ]
    },
    {
      "name": "partition",
      "signature": "partition(count: number, sum: number, options?: {",
      "declarationLines": [
        "partition(count: number, sum: number, options?: {",
        "    minVal?: number;",
        "}): number[];"
      ]
    },
    {
      "name": "matrix",
      "signature": "matrix<T>(rows: number, cols: number, cellGenerator: (r: number, c: number) => T): T[][];",
      "declarationLines": [
        "matrix<T>(rows: number, cols: number, cellGenerator: (r: number, c: number) => T): T[][];"
      ]
    },
    {
      "name": "grid01",
      "signature": "grid01(rows: number, cols: number, density?: number): number[][];",
      "declarationLines": [
        "grid01(rows: number, cols: number, density?: number): number[][];"
      ]
    },
    {
      "name": "maze",
      "signature": "maze(rows: number, cols: number, options?: {",
      "declarationLines": [
        "maze(rows: number, cols: number, options?: {",
        "    wall?: string;",
        "    road?: string;",
        "}): string[][];"
      ]
    },
    {
      "name": "intervals",
      "signature": "intervals(n: number, min: number, max: number, options?: {",
      "declarationLines": [
        "intervals(n: number, min: number, max: number, options?: {",
        "    overlapping?: boolean;",
        "    sorted?: boolean;",
        "    minLen?: number;",
        "    maxLen?: number;",
        "    allowGaps?: boolean;",
        "}): number[][];"
      ]
    },
    {
      "name": "permutation",
      "signature": "permutation(n: number, oneBased?: boolean): number[];",
      "declarationLines": [
        "permutation(n: number, oneBased?: boolean): number[];"
      ]
    },
    {
      "name": "shuffle",
      "signature": "shuffle<T>(array: readonly T[]): T[];",
      "declarationLines": [
        "shuffle<T>(array: readonly T[]): T[];"
      ]
    },
    {
      "name": "sample",
      "signature": "sample<T>(population: readonly T[]): T;",
      "declarationLines": [
        "sample<T>(population: readonly T[]): T;",
        "sample<T>(population: readonly T[], k: number): T[];"
      ]
    },
    {
      "name": "chunk",
      "signature": "chunk<T>(array: readonly T[], size: number): T[][];",
      "declarationLines": [
        "chunk<T>(array: readonly T[], size: number): T[][];"
      ]
    },
    {
      "name": "tree",
      "signature": "tree(n: number, options?: TreeOptions): number[][];",
      "declarationLines": [
        "tree(n: number, options?: TreeOptions): number[][];"
      ]
    },
    {
      "name": "graph",
      "signature": "graph(n: number, m: number, options?: GraphOptions): number[][];",
      "declarationLines": [
        "graph(n: number, m: number, options?: GraphOptions): number[][];"
      ]
    },
    {
      "name": "points",
      "signature": "points(n: number, minVal: number, maxVal: number, options?: {",
      "declarationLines": [
        "points(n: number, minVal: number, maxVal: number, options?: {",
        "    type?: 'random' | 'collinear';",
        "}): number[][];"
      ]
    },
    {
      "name": "convexHull",
      "signature": "convexHull(n: number, minVal: number, maxVal: number): number[][];",
      "declarationLines": [
        "convexHull(n: number, minVal: number, maxVal: number): number[][];"
      ]
    },
    {
      "name": "polygon",
      "signature": "polygon(n: number, minVal: number, maxVal: number): number[][];",
      "declarationLines": [
        "polygon(n: number, minVal: number, maxVal: number): number[][];"
      ]
    },
    {
      "name": "binaryTree",
      "signature": "binaryTree(n: number, options?: BinaryTreeOptions): {",
      "declarationLines": [
        "binaryTree(n: number, options?: BinaryTreeOptions): {",
        "    edges: number[][];",
        "    root: number;",
        "};"
      ]
    },
    {
      "name": "isLeap",
      "signature": "isLeap(year: number): boolean;",
      "declarationLines": [
        "isLeap(year: number): boolean;"
      ]
    },
    {
      "name": "year",
      "signature": "year(minYear?: number, maxYear?: number): number;",
      "declarationLines": [
        "year(minYear?: number, maxYear?: number): number;"
      ]
    },
    {
      "name": "date",
      "signature": "date(options?: {",
      "declarationLines": [
        "date(options?: {",
        "    minYear?: number;",
        "    maxYear?: number;",
        "    format?: string;",
        "}): string;"
      ]
    },
    {
      "name": "debug",
      "signature": "debug<T>(data: T, options?: DebugOptions): void;",
      "declarationLines": [
        "debug<T>(data: T, options?: DebugOptions): void;",
        "debug<T>(label: string, data: T, options?: DebugOptions): void;"
      ]
    }
  ],
  "baseMethods": [
    {
      "name": "convert",
      "signature": "convert(input: string | number | bigint, fromRadix: number, toRadix: number): string;",
      "declarationLines": [
        "convert(input: string | number | bigint, fromRadix: number, toRadix: number): string;"
      ]
    },
    {
      "name": "binToHex",
      "signature": "binToHex(binString: string): string;",
      "declarationLines": [
        "binToHex(binString: string): string;"
      ]
    },
    {
      "name": "hexToBin",
      "signature": "hexToBin(hexString: string): string;",
      "declarationLines": [
        "hexToBin(hexString: string): string;"
      ]
    },
    {
      "name": "digits",
      "signature": "digits(length: number, radix: number): string;",
      "declarationLines": [
        "digits(length: number, radix: number): string;"
      ]
    }
  ],
  "charsetProperties": [
    "LOWERCASE",
    "UPPERCASE",
    "DIGITS",
    "ALPHANUMERIC",
    "ALPHA",
    "BASE36"
  ]
} as const;
